export const contentTypeJSON = 'application/json';
export const authorizationBearer = 'Bearer '; // don't delete space !!!
export const actionDefault = 'ACTION_DEFAULT';
